export default __webpack_public_path__ + "static/media/Playground.f9776a63.png";